export default {"src":"/_next/static/media/search-icon.a1468c10.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};